export default {
  'app.settings.hasNoSetting': 'Not configured',
};
